var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tr",
    [
      _vm._t("default"),
      _c("td", { staticStyle: { "min-width": "20px" } }, [
        _c(
          "div",
          { staticClass: "btn-copy" },
          [
            _c(
              _setup.baseButton,
              {
                on: {
                  click: function ($event) {
                    return _setup.copyToClipboard(_vm.value)
                  },
                },
              },
              [
                _c(_setup.SvgIcon, {
                  attrs: { path: _setup.path.copy, size: "14", type: "mdi" },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }